<template>
  <v-card v-if="items">
    <v-card-title class="ml-2">
      <span class="table-card-title">Resultados por loja</span>
      <v-spacer />
      <export-data :data-fetcher="getDataToExport" filename="resultados_por_loja" ghost />
    </v-card-title>
    <v-data-table
      class="ml-6 mr-4"
      :items="items"
      :loading="loading"
      :headers="headers"
      hide-default-footer
      disable-pagination
      no-data-text="Não há resultados por loja neste banner"
    >
      <template v-slot:item.revenue="{ item }">
        {{ setCurrencyValue(item.revenue) }}
      </template>

      <template v-slot:item.discount="{ item }">
        {{ setCurrencyValue(item.discount * (item.discount >= 0 ? 1 : -1)) }}
      </template>

      <template v-slot:item.clients="{ item }">
        {{ item.clients }}
      </template>

      <template v-slot:item.averageTicket="{ item }">
        {{ setCurrencyValue(item.averageTicket) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { localeString } from '@/config/helpers.js'
import ExportData from '@/components/export-data/ExportData.vue'

export default {
  name: 'ResultsUnitsTable',
  components: {
    ExportData,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    headers() {
      return [
        {
          text: 'Loja',
          value: 'name',
          width: '30%',
        },
        {
          text: 'Clientes que clicaram',
          value: 'clients',
          width: '20%',
        },
        {
          text: 'Faturamento',
          value: 'revenue',
          width: '30%',
        },
        {
          text: 'Ticket médio',
          value: 'averageTicket',
          width: '20%',
        },
      ]
    },
  },
  methods: {
    setCurrencyValue(value) {
      return `R$ ${localeString(value, 2)}`
    },
    getDataToExport() {
      const headers = this.headers.map((header) => header.text)
      const rows = this.items.map((item) =>
        this.headers.map((header) => {
          if (header.value.includes('.')) {
            const attrs = header.value.split('.')
            const rowType = typeof item[attrs[0]][attrs[1]]
            return rowType === 'number'
              ? localeString(item[attrs[0]][attrs[1]] < 0 ? item[attrs[0]][attrs[1]] * -1 : item[attrs[0]][attrs[1]], 2)
              : item[attrs[0]][attrs[1]]
          }
          const rowType = typeof item[header.value]
          return rowType === 'number' ? localeString(item[header.value] < 0 ? item[header.value] * -1 : item[header.value], 2) : item[header.value]
        })
      )
      return { headers, rows }
    },
  },
}
</script>
